module.exports = __webpack_public_path__ + "static/media/Project_Placeholder_Image.ea5ca87c.svg";